//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions, mapState } from 'vuex';
export default{
  data: function(){
    return {

    }
  },
  computed: {
  	...mapState({
  		article: ({ shopro }) => shopro.article,
  	}),
  },
  watch:{
  },
  created() {

  },
  mounted() {
    console.log(this.article)
  },
  methods:{

  }
}



// WEBPACK FOOTER //
// ./src/components/footer.vue